import { HealthcareFacilityUnit, HealthcareFacilityUnitQuery } from '@dreryk/egabinet-healthcare-provider-frontend-api';

import { useCqrsGet } from '@dreryk/command-query-react-common';
import { LoaderSpinner, Message, MessageType } from '@dreryk/react-components';
import { Slot } from '@dreryk/watermelon';

import { healthcareOrganizationTranslationKeys } from '../../../../../translations';

type HealthcareFacilityUnitUpdateFormLoaderRenderProps = {
   healthcareFacilityUnit: HealthcareFacilityUnit;
};

type HealthcareFacilityUnitUpdateFormLoaderProps = {
   readonly healthcareFacilityUnitId: number;
   readonly children: (renderProps: HealthcareFacilityUnitUpdateFormLoaderRenderProps) => JSX.Element;
};

export const HealthcareFacilityUnitUpdateFormLoader = (
   props: HealthcareFacilityUnitUpdateFormLoaderProps
): JSX.Element => {
   const {
      data: healthcareFacilityUnit,
      loading: healthcareFacilityUnitLoading,
      error: healthcareFacilityUnitError,
   } = useCqrsGet<HealthcareFacilityUnit>(() => {
      const query = new HealthcareFacilityUnitQuery();
      query.id = Slot.of(props.healthcareFacilityUnitId);
      return query;
   });

   if (healthcareFacilityUnitLoading) {
      return <LoaderSpinner />;
   }

   if (healthcareFacilityUnitError) {
      return (
         <Message
            testId={'failedToFetchHealthcareFacilityUnit'}
            label={healthcareOrganizationTranslationKeys.failedToFetchHealthcareFacilityUnit}
            type={MessageType.NEGATIVE}
            displayIndicator
         />
      );
   }

   return props.children({
      healthcareFacilityUnit: healthcareFacilityUnit,
   });
};
